import moment, { Moment } from "moment-timezone";

const DEFAULT_MAX_STOCK = 500;

export class ArticleStock {
    id: number;
    articleId: number;
    quantity: number;
    validityDate: Moment;

    constructor(data?: Partial<ArticleStock>) {
        this.id = data?.id ?? 0;
        this.articleId = data?.articleId ?? 0;
        this.quantity = data?.quantity ?? 0;
        this.validityDate = data?.validityDate ?? moment();
    }
}

// Helper function to check if an item has enough stock
export function hasEnoughStock(
    articleId: number,
    requestedQuantity: number,
    articleStocks: Map<number, ArticleStock[]>
): boolean {
    if (requestedQuantity === 0) return true;

    const stocksForArticle = articleStocks.get(articleId);
    const articleStock = stocksForArticle?.[0]; // Take first stock entry

    if (!articleStock) {
        // If no stock info available, allow up to 500 as fallback
        return requestedQuantity <= DEFAULT_MAX_STOCK;
    }

    return articleStock.quantity >= requestedQuantity;
}

// Helper function to get max available stock for an article
export function getMaxAvailableStock(
    articleId: number,
    articleStocks: Map<number, ArticleStock[]>
): number {
    const stocksForArticle = articleStocks.get(articleId);
    const articleStock = stocksForArticle?.[0]; // Take first stock entry

    if (!articleStock) {
        // If no stock info available, return 500 as fallback
        return DEFAULT_MAX_STOCK;
    }

    return articleStock.quantity;
}
